import { ArrowRight } from 'lucide-react';

import { SecondaryCTA } from '../components/SecondaryCTA';
import { SectionWrapper } from '../components/SectionWrapper';

import styles from './AIKaiCoachSection.module.css';

const figures = [
  { label: 'developed arguments per paper', value: '2×' },
  { label: 'stated a clear position, up from 43%', value: '73%' },
  { label: 'of final exams cited a specific reading, up from 7%', value: '87%' },
] as const;

/** The band under the AI hero that introduces Kai Coach. */
export function AIKaiCoachSection() {
  return (
    <SectionWrapper
      aria-labelledby="ai-kai-coach-title"
      background="white"
      className={styles.root}
      contentClassName={styles.content}
      data-testid="ai-section-kai-coach"
    >
      <div className={styles.copy}>
        <p className={styles.kicker}>New in KAI</p>
        <h2 className={styles.title} id="ai-kai-coach-title">
          Kai Coach: the AI coach that never writes the paper.
        </h2>
        <p className={styles.body}>
          Socratic coaching modules built on your course’s own readings, and built by Kudu at no
          cost to your institution. When a student is stuck, Kai Coach may supply a term, never the
          reasoning.
        </p>
        <SecondaryCTA
          href="/kai-coach"
          icon={<ArrowRight aria-hidden="true" size={16} />}
          label="Explore Kai Coach"
        />
      </div>
      <ul aria-label="First course pilot, History 2C at UCLA" className={styles.figures}>
        {figures.map((figure) => (
          <li className={styles.figure} key={figure.value}>
            <span className={styles.value}>{figure.value}</span>
            <span className={styles.label}>{figure.label}</span>
          </li>
        ))}
      </ul>
    </SectionWrapper>
  );
}
